import { render, staticRenderFns } from "./logStudent.vue?vue&type=template&id=57088a23&"
import script from "./logStudent.vue?vue&type=script&lang=js&"
export * from "./logStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports